"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_ACTIVITY_POINT_VALUES = exports.SLIDE_VIEW_POINT_VALUE = exports.WELCOME_VIDEO_POINTS = void 0;
exports.WELCOME_VIDEO_POINTS = 5;
exports.SLIDE_VIEW_POINT_VALUE = 10;
exports.MODULE_ACTIVITY_POINT_VALUES = {
    SELF_CARE_ACTIVITY_CHECKLIST: 10,
    DEPRESSION_MANAGEMENT_PLAN: 10,
    MOOD_SPIRAL_VIDEO: 5,
    COPING_WITH_STRESS_LET_THOUGHTS_GO_VIDEO: 5,
    COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO: 5,
    COPING_WITH_STRESS_BREATHING_EXAMPLE_VIDEO: 5,
    RULES_AND_CONSEQUENCES_IGNORING_VIDEO: 5,
    POSITIVE_PARENTING_GIVING_DIRECTIONS_VIDEO: 5,
    POSITIVE_PARENTING_NOTICE_BEHAVIOR_VIDEO: 5,
    HEALTHY_ROUTINES_SATISFACTION_MOODS: 10,
    HEALTHY_ROUTINES_PLAN: 10,
    SLEEP_HABITS_ROOM: 10,
    COPING_WITHOUT_ALCOHOL_AND_DRUGS_MYTH_OR_FACT: 10,
    COPING_WITHOUT_ALCOHOL_AND_DRUGS_REASONS: 10,
    COPING_WITHOUT_ALCOHOL_AND_DRUGS_TRIGGERS: 10,
    COPING_WITHOUT_ALCOHOL_AND_DRUGS_OUTRO_VIDEO: 10,
    EFFECTIVE_COMMUNICATION_VIDEO: 10,
    EFFECTIVE_COMMUNICATION_COMPARISON_STATEMENT: 10,
    PARENTING_AND_SUBSTANCE_USE_CRAVING_TIP_BAG: 10,
    HOME_SAFETY_DO_OR_DONT_QUIZ: 10,
    WHAT_IS_POSITIVE_PARENTING_DESCRIPTION_QUIZ: 10,
    ENCOURAGEMENT_AND_PRAISE_NOTICING_VIDEO: 5,
    ENCOURAGEMENT_AND_PRAISE_EXAMPLES_OF_PRAISE_QUIZ: 10,
    RELATIONSHIP_BUILDING_SITUATION_EXAMPLE_1: 10,
    RELATIONSHIP_BUILDING_SITUATION_EXAMPLE_2: 10,
    GIVING_DIRECTION_HELPFUL_OR_UNHELPFUL_QUIZ: 10,
    USING_INCENTIVES_BRIBE_VS_REWARD_1: 10,
    USING_INCENTIVES_BRIBE_VS_REWARD_2: 10,
    PRAISE_IDEA_GROWTH: 10,
    PROACTIVE_PARENTING_PLAN_QUIZ: 10,
    PROACTIVE_PARENTING_PROACTIVE_OR_NOT_QUIZ: 10,
    PROACTIVE_PARENTING_PLAY_COMMITMENT: 10,
    PROACTIVE_PARENTING_BEDTIME_ROUTINE_VIDEO: 5,
    PROACTIVE_PARENTING_PLAY_VIDEO: 5,
    PROACTIVE_PARENTING_TIP_BAG: 10,
    RULES_AND_CONSEQUENCES_SUPERVISION_LESSON: 10,
    RULES_AND_CONSEQUENCES_ROOMS: 10,
    RULES_AND_CONSEQUENCES_CLEAR_OR_NOT_QUIZ: 10,
    RULES_AND_CONSEQUENCES_LOGICAL_OR_NOT_QUIZ: 10,
    RULES_AND_CONSEQUENCES_WHEN_THEN_MATCH: 10,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9pbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9wb2ludHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxvQkFBb0IsR0FBRyxDQUFDLENBQUM7QUFFekIsUUFBQSxzQkFBc0IsR0FBRyxFQUFFLENBQUM7QUFFNUIsUUFBQSw0QkFBNEIsR0FHckM7SUFDRiw0QkFBNEIsRUFBRSxFQUFFO0lBQ2hDLDBCQUEwQixFQUFFLEVBQUU7SUFDOUIsaUJBQWlCLEVBQUUsQ0FBQztJQUNwQix3Q0FBd0MsRUFBRSxDQUFDO0lBQzNDLDJDQUEyQyxFQUFFLENBQUM7SUFDOUMsMENBQTBDLEVBQUUsQ0FBQztJQUM3QyxxQ0FBcUMsRUFBRSxDQUFDO0lBQ3hDLDBDQUEwQyxFQUFFLENBQUM7SUFDN0Msd0NBQXdDLEVBQUUsQ0FBQztJQUMzQyxtQ0FBbUMsRUFBRSxFQUFFO0lBQ3ZDLHFCQUFxQixFQUFFLEVBQUU7SUFDekIsaUJBQWlCLEVBQUUsRUFBRTtJQUNyQiw2Q0FBNkMsRUFBRSxFQUFFO0lBQ2pELHdDQUF3QyxFQUFFLEVBQUU7SUFDNUMseUNBQXlDLEVBQUUsRUFBRTtJQUM3Qyw0Q0FBNEMsRUFBRSxFQUFFO0lBQ2hELDZCQUE2QixFQUFFLEVBQUU7SUFDakMsNENBQTRDLEVBQUUsRUFBRTtJQUNoRCwyQ0FBMkMsRUFBRSxFQUFFO0lBQy9DLDJCQUEyQixFQUFFLEVBQUU7SUFDL0IsMkNBQTJDLEVBQUUsRUFBRTtJQUMvQyx1Q0FBdUMsRUFBRSxDQUFDO0lBQzFDLGdEQUFnRCxFQUFFLEVBQUU7SUFDcEQseUNBQXlDLEVBQUUsRUFBRTtJQUM3Qyx5Q0FBeUMsRUFBRSxFQUFFO0lBQzdDLDBDQUEwQyxFQUFFLEVBQUU7SUFDOUMsa0NBQWtDLEVBQUUsRUFBRTtJQUN0QyxrQ0FBa0MsRUFBRSxFQUFFO0lBQ3RDLGtCQUFrQixFQUFFLEVBQUU7SUFDdEIsNkJBQTZCLEVBQUUsRUFBRTtJQUNqQyx5Q0FBeUMsRUFBRSxFQUFFO0lBQzdDLG1DQUFtQyxFQUFFLEVBQUU7SUFDdkMseUNBQXlDLEVBQUUsQ0FBQztJQUM1Qyw4QkFBOEIsRUFBRSxDQUFDO0lBQ2pDLDJCQUEyQixFQUFFLEVBQUU7SUFDL0IseUNBQXlDLEVBQUUsRUFBRTtJQUM3Qyw0QkFBNEIsRUFBRSxFQUFFO0lBQ2hDLHdDQUF3QyxFQUFFLEVBQUU7SUFDNUMsMENBQTBDLEVBQUUsRUFBRTtJQUM5QyxzQ0FBc0MsRUFBRSxFQUFFO0NBQzNDLENBQUMifQ==